import { CheckCircle2, AlertTriangle, AlertOctagon, Info, Circle, Clock } from "lucide-react";

const MAP = {
  success: { cls: "bg-success/10 text-success border-success/25", Icon: CheckCircle2 },
  warning: { cls: "bg-warning/10 text-warning border-warning/25", Icon: AlertTriangle },
  danger: { cls: "bg-danger/10 text-danger border-danger/25", Icon: AlertOctagon },
  info: { cls: "bg-brand/10 text-brand border-brand/25", Icon: Info },
  pending: { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: Clock },
  neutral: { cls: "bg-slate-100 text-slate-600 border-slate-200", Icon: Circle },
};

/**
 * Badge di stato del design system: SEMPRE colore + testo + icona (mai solo colore).
 */
export function StatusBadge({ type = "neutral", children, icon: Custom, className = "", testid }) {
  const conf = MAP[type] || MAP.neutral;
  const Icon = Custom || conf.Icon;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${conf.cls} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {children}
    </span>
  );
}
